const shouldManageBodyStyle = () => {
    return !document.body.classList.contains('ov-hidden') && true;
};

export default shouldManageBodyStyle;
